import { useState } from "react";
import moment from "moment";
import VendorOverView from './VendorOverView';
import VendorFailureTypes from './VendorFailureTypes';
import VendorDailyTrend from './VendorDailyTrend';
import VendorHourlyHeatmap from './VendorHourlyHeatmap';
import VendorDistrictFailures from './VendorDistrictFailures';
import VendorOperatorDrilldown from './VendorOperatorDrilldown';
import DateRangeSelector, { DateRange } from "../../component/DateRangeSelector/DateRangeSelector";
import { useTheme } from "../../theme/useTheme";

export default function VendorReverificationStats() {
    const { colors } = useTheme();
    const [dateRange, setDateRange] = useState<DateRange>({
        startDate: moment().subtract(7, 'days').startOf('day').toDate(),
        endDate: moment().endOf('day').toDate(),
    });

    return (
        <div style={{ padding: "2rem 1.5rem" }}>
            {/* Page Header */}
            <div
                className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4 pb-3"
                style={{ borderBottom: `2px solid ${colors.border.light}` }}
            >
                <div>
                    <h4 className="mb-1 fw-bold" style={{ color: colors.text.primary, fontSize: "1.4rem" }}>
                        Vendor Reverification Stats
                    </h4>
                    <span style={{ color: colors.text.muted, fontSize: "0.82rem" }}>
                        {moment(dateRange.startDate).format("DD MMM YYYY")} &mdash; {moment(dateRange.endDate).format("DD MMM YYYY")}
                    </span>
                </div>
                <div
                    className="d-flex align-items-center gap-2 px-3 py-2"
                    style={{
                        background: colors.background.secondary,
                        borderRadius: "10px",
                        border: `1px solid ${colors.border.light}`,
                    }}
                >
                    <DateRangeSelector value={dateRange} onChange={setDateRange} />
                </div>
            </div>

            <VendorOverView dateRange={dateRange} />
            <VendorFailureTypes dateRange={dateRange} />
            <VendorDailyTrend dateRange={dateRange} />
            <VendorHourlyHeatmap dateRange={dateRange} />
            <VendorDistrictFailures dateRange={dateRange} />
            <VendorOperatorDrilldown dateRange={dateRange} />
        </div>
    );
}
